/**
 * @packageDocumentation
 * @module api.functional.items
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { PaginationQuerycategoryNamestringundefinedsearchstringundefinedlowStockbooleanundefinedpopulateStockHistorybooleanundefined } from "../../structures/PaginationQuerycategoryNamestringundefinedsearchstringundefinedlowStockbooleanundefinedpopulateStockHistorybooleanundefined";
import type { ServiceResponseboolean } from "../../structures/ServiceResponseboolean";
import type { ServiceResponsenull } from "../../structures/ServiceResponsenull";
import type { ServiceResponsePageOfItem } from "../../structures/ServiceResponsePageOfItem";
import type { UpdateItemDto } from "../../structures/UpdateItemDto";

export * as categories from "./categories/index";
export * as stock_history from "./stock_history/index";
export * as reservations from "./reservations/index";

/**
 * @controller ItemController.getItems
 * @path GET /items
 * @accessor api.functional.items.getItems
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function getItems(
  connection: IConnection,
  filters: getItems.Query,
): Promise<getItems.Output> {
  return PlainFetcher.fetch(connection, {
    ...getItems.METADATA,
    template: getItems.METADATA.path,
    path: getItems.path(filters),
  });
}
export namespace getItems {
  export type Query =
    PaginationQuerycategoryNamestringundefinedsearchstringundefinedlowStockbooleanundefinedpopulateStockHistorybooleanundefined;
  export type Output = ServiceResponsenull | ServiceResponsePageOfItem;

  export const METADATA = {
    method: "GET",
    path: "/items",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (filters: Query) => {
    const variables: URLSearchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(filters as any))
      if (undefined === value) continue;
      else if (Array.isArray(value))
        value.forEach((elem: any) => variables.append(key, String(elem)));
      else variables.set(key, String(value));
    const location: string = "/items";
    return 0 === variables.size
      ? location
      : `${location}?${variables.toString()}`;
  };
}

/**
 * @controller ItemController.updateItem
 * @path PATCH /items/:id
 * @accessor api.functional.items.updateItem
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function updateItem(
  connection: IConnection,
  id: string,
  body: updateItem.Body,
): Promise<updateItem.Output> {
  return PlainFetcher.fetch(
    {
      ...connection,
      headers: {
        ...connection.headers,
        "Content-Type": "application/json",
      },
    },
    {
      ...updateItem.METADATA,
      template: updateItem.METADATA.path,
      path: updateItem.path(id),
    },
    body,
  );
}
export namespace updateItem {
  export type Body = UpdateItemDto;
  export type Output = ServiceResponseboolean | ServiceResponsenull;

  export const METADATA = {
    method: "PATCH",
    path: "/items/:id",
    request: {
      type: "application/json",
      encrypted: false,
    },
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (id: string) =>
    `/items/${encodeURIComponent(id?.toString() ?? "null")}`;
}
